export const GET_SAVED_VIEW_MSW_STATUS_KEY = 'getSavedViewAPI';
export const GET_SAVED_VIEW_KEY = 'GET_SAVED_VIEW';
export const POST_SAVED_VIEW_MSW_STATUS_KEY = 'postSavedViewAPI';
export const PUT_SAVED_VIEW_MSW_STATUS_KEY = 'putSaveViewAPI';
export const DELETE_SAVED_VIEW_MSW_STATUS_KEY = 'deleteSavedViewAPI';
